module.exports = __webpack_public_path__ + "img/news.e89ae126.svg";